import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={26} height={26} rx={6} fill="#352A1F" />
    <path
      d="M4.67263 17.711L3.53686 16.5752L3 17.1122L4.6726 18.7848L7.89393 15.5427L7.35707 15.0059L4.67263 17.711Z"
      fill="#BC9B6A"
    />
    <path
      d="M3.47491 10.9028L4.96169 9.43675L6.4279 10.9028L6.90281 10.4279L5.4366 8.96169L6.90281 7.49563L6.4279 7L4.96169 8.46621L3.47491 7L3 7.49563L4.46621 8.96169L3 10.4279L3.47491 10.9028Z"
      fill="#BC9B6A"
    />
    <path
      d="M7.90234 7V10.8202H22.254V7H7.90234ZM21.5106 10.0975H8.64574V7.74339H21.5106V10.0975Z"
      fill="#BC9B6A"
    />
    <path
      d="M7.89453 18.7226H22.2461V14.9023H7.89453V18.7226ZM8.63792 15.6457H21.5028V17.9998H8.63792V15.6457Z"
      fill="#BC9B6A"
    />
  </svg>
);
export default SVGComponent;
